import React, {createElement, useState, Fragment, useRef} from 'react';
import Player from '@ifeng/three_terminal/es/pc/video/output/pcVideo.jsx';
import md5 from 'md5';
import Skin1 from './skin1.module.scss';
import Skin2 from './skin2.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface VideoList_1_Props {
    nodeId?: string
    style?: object;
    width: number; // 播放器宽
    height: number; // 播放器高
    autoPlay: boolean; // 是否自动播放
    controls: boolean; // 是否显示播放控件
    continuePlay: boolean; // 是否自动联播
    videoChip: TYPE_Chip;

    listIcon?: string // 视频列表前的小图标
    listIconWidth?: number // 视频列表前的小图标宽度
    listIconHeight?: number // 视频列表前的小图标高度
    listStyle?: object // 视频列表单条样式
    hoverColor: string;

    skin: number;
}

const VideoList_1: React.FC<VideoList_1_Props> = (props: VideoList_1_Props) => {
    const { nodeId, style, width, height, autoPlay, controls, continuePlay, videoChip, listIcon, listIconWidth, listIconHeight, listStyle, hoverColor, skin } = props;
    const Style = [Skin1, Skin2][skin || 0];

    const playList = useChip(videoChip);
    const playListChipComponentData = formatChip(videoChip)

    const [playIndex, setPlayIndex] = useState(0);
    const playFuncRef = useRef((i: number) => {})

    const getKey = () => {
        return md5(JSON.stringify({ ...props, playList }));
    };

    const play = (index) => {
        setPlayIndex(index)
        playFuncRef.current(index)
    }

    return (
        <Chip {...playListChipComponentData}>
            <div
                id={nodeId}
                className={Style.wrap}
                style={{
                    ...(skin === 0 ? { width: `${width}px`, display: 'inline-block' } : {}),
                    ...style,
                }}
            >
                {playList.length ? (
                    <Fragment>
                        <div className={Style.player}>
                            <Player
                                key={getKey()}
                                videoConfig={playList}
                                playermsg={{
                                    width,
                                    height,
                                    autoPlay,
                                    controls,
                                    playerHooks:({ changePlayIndex }) => {
                                        playFuncRef.current = changePlayIndex
                                    },
                                    playerEventTrigger: (player) => {
                                        if (continuePlay) {
                                            player.on('ended', () => {
                                                if (playIndex < playList.length - 1) {
                                                    setPlayIndex(playIndex + 1)
                                                    playFuncRef.current(playIndex + 1)
                                                } else {
                                                    setPlayIndex(0)
                                                    playFuncRef.current(0)
                                                }
                                            });
                                        }
                                        player.on('canplay', () => {
                                            player.play();
                                        });
                                    }
                                }}
                            />
                        </div>
                        <div className={Style.playList} style={skin === 1 ? { height } : {}}>
                            {playList.map((item, index) => {
                                const { title } = item;

                                return (
                                    // @ts-ignore
                                    <div className={Style.playItem} onClick={() => play(index)} style={{ ...listStyle, ...{'--color-hover': hoverColor}, ...(index === playIndex ? { color: hoverColor } : {}) }}>
                                        <img src={listIcon || "https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"} style={{ width: `${listIconWidth}px`, height: `${listIconHeight}px` }} alt=""/>
                                        <span>{title}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </Fragment>
                ) : null}
                <Mask visible={!videoChip.id} zIndex={3}>
                    示例推荐位碎片—{videoChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default VideoList_1;
